export const useModalStore = defineStore('modalStore', {
  state: () => ({
    modal: {
      id: '',
      title: '',
      width: '',
      component: null,
      props: {},
    },
  }),
  actions: {
    setModal(modal) {
      this.modal = modal;
    },
  },
});
